import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Apply from "@/pages/Apply";
import ApplicationSubmitted from "@/pages/ApplicationSubmitted";
import MerchantLanding from "@/pages/MerchantLanding";
import DriverLanding from "@/pages/DriverLanding";
import TrackDelivery from "@/pages/TrackDelivery";
import Pricing from "@/pages/Pricing";
import AuthCallback from "@/pages/AuthCallback";
import GoogleOnboarding from "@/pages/GoogleOnboarding";
import FAQ from "@/pages/FAQ";
import HowItWorks from "@/pages/HowItWorks";
import Contact from "@/pages/Contact";

import DriverLayout from "@/pages/driver/DriverLayout";
import DriverOverview from "@/pages/driver/DriverOverview";
import DriverDeliveries from "@/pages/driver/DriverDeliveries";
import DeliveryDetail from "@/pages/driver/DeliveryDetail";
import DriverDocuments from "@/pages/driver/DriverDocuments";
import DriverEarnings from "@/pages/driver/DriverEarnings";
import DriverProfile from "@/pages/driver/DriverProfile";

import MerchantLayout from "@/pages/merchant/MerchantLayout";
import MerchantOverview from "@/pages/merchant/MerchantOverview";
import CreateDelivery from "@/pages/merchant/CreateDelivery";
import MerchantOrders from "@/pages/merchant/MerchantOrders";
import OrderDetail from "@/pages/merchant/OrderDetail";
import MerchantBilling from "@/pages/merchant/MerchantBilling";
import MerchantLocations from "@/pages/merchant/MerchantLocations";
import MerchantProfile from "@/pages/merchant/MerchantProfile";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminApplicants from "@/pages/admin/AdminApplicants";
import ApplicantDetail from "@/pages/admin/ApplicantDetail";
import AdminDrivers from "@/pages/admin/AdminDrivers";
import AdminMerchants from "@/pages/admin/AdminMerchants";
import AdminDispatch from "@/pages/admin/AdminDispatch";
import AdminRegions from "@/pages/admin/AdminRegions";
import AdminReports from "@/pages/admin/AdminReports";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ style: { fontFamily: "Inter", borderRadius: 0 } }} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/for-merchants" element={<MerchantLanding />} />
          <Route path="/for-drivers" element={<DriverLanding />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/application-submitted" element={<ApplicationSubmitted />} />
          <Route path="/track/:token" element={<TrackDelivery />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/onboarding" element={<GoogleOnboarding />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/driver" element={<ProtectedRoute role="driver"><DriverLayout /></ProtectedRoute>}>
            <Route index element={<DriverOverview />} />
            <Route path="deliveries" element={<DriverDeliveries />} />
            <Route path="deliveries/:id" element={<DeliveryDetail />} />
            <Route path="documents" element={<DriverDocuments />} />
            <Route path="earnings" element={<DriverEarnings />} />
            <Route path="profile" element={<DriverProfile />} />
          </Route>

          <Route path="/merchant" element={<ProtectedRoute role="merchant"><MerchantLayout /></ProtectedRoute>}>
            <Route index element={<MerchantOverview />} />
            <Route path="create" element={<CreateDelivery />} />
            <Route path="orders" element={<MerchantOrders />} />
            <Route path="orders/:id" element={<OrderDetail />} />
            <Route path="billing" element={<MerchantBilling />} />
            <Route path="locations" element={<MerchantLocations />} />
            <Route path="profile" element={<MerchantProfile />} />
          </Route>

          <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminApplicants />} />
            <Route path="applicants/:id" element={<ApplicantDetail />} />
            <Route path="drivers" element={<AdminDrivers />} />
            <Route path="merchants" element={<AdminMerchants />} />
            <Route path="dispatch" element={<AdminDispatch />} />
            <Route path="regions" element={<AdminRegions />} />
            <Route path="reports" element={<AdminReports />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
